import React, { useRef, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Img from "../Assets/icons/VELOXLogo.png";
import UserIcon from "../Assets/icons/User.svg";
import { ToastContainer } from 'react-toastify';
import "../Styles/UserProfileHeader.css";

const MDUserProfileHeader = ({ isAdmin }) => {
  const navigate = useNavigate();
  const { mdId } = useParams();
  const [open, setOpen] = useState(false);
  const [activeButton, setActiveButton] = useState("");
  const menuRef = useRef(null);
  const iconRef = useRef(null);
  const role = localStorage.getItem('role');

  // If someone hits this page without mdId in the path, bounce home
  useEffect(() => {
    if (!mdId) navigate("/", { replace: true });
  }, [mdId, navigate]);

  // Persist MD so it survives the auth flow
  useEffect(() => {
    if (mdId) localStorage.setItem("md_ref", mdId);
  }, [mdId]);

  useEffect(() => {
    setActiveButton(window.location.pathname);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const menuEl = menuRef.current;
      const iconEl = iconRef.current;

      // If refs not ready, do nothing
      if (!menuEl || !iconEl) return;

      if (!menuEl.contains(event.target) && !iconEl.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const handleToggle = () => setOpen(prev => !prev);

  const handleNavClick = (path) => {
    setActiveButton(path);
    setOpen(false);
    navigate(path);
  };

  const handleLogout = () => {
    setOpen(false);
    localStorage.removeItem('@user');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('siId');
    localStorage.removeItem('siId_locked');
    localStorage.removeItem('role');
    // optional: also clear md_ref if you don't want it kept
    // localStorage.removeItem('md_ref');
    window.location.replace(`/${mdId}/login`);
  };

  // Menu actions (close menu first, then navigate)
  const goUpdatePassword = () => handleNavClick(`/${mdId}/update_password`);
  const goCreateSI = () => handleNavClick(`/${mdId}/create_si`);
  const goCreateUserInCompany = () => handleNavClick(`/${mdId}/create_t`);
  const goVeloxLogs = () => handleNavClick(`/${mdId}/md_logs`);
  const goRequestCloudKey = () => handleNavClick(`/${mdId}/request_cloud_key`);
  const goAssignCloudKey = () => handleNavClick(`/${mdId}/assign_SI_cloud_key`);

  return (
    <>
      <div className='logo-VELOX'>
        <img src={Img} alt="VELOX Life Safety Inc." className="logo" />

        {/* Buttons next to logo */}
        <div className="header-button-group">
          {(role == 1) && (<button
            className={activeButton === `/${mdId}/md_management` ? 'fancy-button selected' : 'fancy-button'}
            onClick={() => handleNavClick(`/${mdId}/md_management`)}
          >
            Master Distributor Users Management
          </button>)}

          <button
            className={activeButton === `/${mdId}/si_management` ? 'fancy-button selected' : 'fancy-button'}
            onClick={() => handleNavClick(`/${mdId}/si_management`)}
          >
            System Integrator Users Management
          </button>

          <button
            className={activeButton === `/${mdId}/yubikey_dashboard` ? 'fancy-button selected' : 'fancy-button'}
            onClick={() => handleNavClick(`/${mdId}/yubikey_dashboard`)}
          >
            VELOX Cloud Key Dashboard
          </button>

          <button
            className={activeButton === `/${mdId}/md_commissioningtool` ? 'fancy-button selected' : 'fancy-button'}
            onClick={() => handleNavClick(`/${mdId}/md_commissioningtool`)}
          >
            Commissioning Tool
          </button>
        </div>

        <img
          src={UserIcon}
          alt="User Profile"
          className="user-pic"
          onClick={handleToggle}
          ref={iconRef}
        />
      </div>

      <hr className='login-breakline' />

      {open && (
        <div className="sub-menu-wrap open-menu" ref={menuRef}>
          <div className="sub-menu">
            {(role == 1) && (<button type="button" className="sub-menu-link" onClick={goCreateSI}>
              <p>Create System Integrator Admin</p>
            </button>)}
            
            {(role == 1 || role == 3) && (<button type="button" className="sub-menu-link" onClick={goCreateUserInCompany}>
              <p>Create User In Your Company</p>
            </button>)}

            {(role == 1) && (<button type="button" className="sub-menu-link" onClick={goRequestCloudKey}>
              <p>Request VELOX CLOUD Key</p>
            </button>)}

            {(role == 1) && (<button type="button" className="sub-menu-link" onClick={goAssignCloudKey}>
              <p>Assign VELOX CLOUD Key to System Integrator</p>
            </button>)}

            <button type="button" className="sub-menu-link" onClick={goVeloxLogs}>
              <p>Logs</p>
            </button>

            <button type="button" className="sub-menu-link" onClick={goUpdatePassword}>
              <p>Change Password</p>
            </button>

            <button type="button" className="sub-menu-link" onClick={handleLogout}>
              <p>Log Out</p>
            </button>
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default MDUserProfileHeader;
